import { ReferencedEntry } from 'contentful';
import React from 'react';
import { ModalAssembly, ModalType } from 'src/api/contentful/contentTypes.cloverdotcom';

import { getField, isEntry } from 'src/utils/EntryUtil';
import { EnhancedMedia } from '../EnhancedMedia/EnhancedMedia';
import { PartnerContactWrapper } from '../IntegrationServices/PartnerContactWrapper';
import { TextModal } from '../TextModal/TextModal';

export interface IModalModuleContentWrapper {
  entry?: ReferencedEntry<ModalAssembly>;
  children?: never;
  modalBaseUrl?: string;
}

export const ModalModuleContentWrapper: React.FC<IModalModuleContentWrapper> = ({ entry, modalBaseUrl }) => {
  if (!isEntry(entry)) return null;

  switch (entry.fields.type) {
    case ModalType.MediaOnly:
      return (
        <EnhancedMedia
          entry={getField(entry, 'topic')}
          controls
          autoPlay
          mediaProps={{ height: '100%', width: '100%' }}
        />
      );
    case ModalType.PartnerContactForm:
      return (
        <PartnerContactWrapper entry={getField(entry, 'topic')} />
      );
    case ModalType.Text:
      return (
        <TextModal entry={getField(entry, 'topic')} modalBaseUrl={modalBaseUrl} />
      );
    default:
      return null;
  }
};
